module.exports = __webpack_public_path__ + "static/media/200261A.4232c58b.jpg";